import React, { Component, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from 'axios';
import { getApiHeader, getApiHeaderGuest, removeUserSession } from '../../../utils/CommonFunctions';
import { Link } from "react-router-dom";
import swal from '@sweetalert/with-react';
import PageLoader from '../../Loader/loader';
import PaymentPopup from './PopupPendingDue';
import maleUserImg from '../../../assets/media/users/computer-icons-user-profile-avatar.jpg'
import femaleUserImg from '../../../assets/media/users/user_female_avatar.png';
import { Pie, Doughnut } from 'react-chartjs-2';




const SERVER_URL = process.env.REACT_APP_SERVER_URL;




class PostPaidAccoutSummary extends Component {


    state = {
        customer_activations: [],
        account_summary: [],
        selected_number: "",
        selected_mobile_number: "",
        customMesssge: null,
        loading: false,
        graph_data: {
            labels: ['Used Data', 'Balance Data'],
            datasets: [
                {
                    label: 'Rainfall',
                    backgroundColor: [
                        '#C11D6C',
                        '#4ac959'
                    ],
                    hoverBackgroundColor: [
                        '#C11D6C',
                        '#4ac959'
                    ],
                    data: [0, 0]
                }
            ]
        },
        activeShow: true,
        graph_usedData: 0,
        graph_TotalData: 0,
        data_gift_sent: 0,
        data_gift_received: 0,
        sixth_recharge_status: false,
        recharge_count: 0,
        no_recharge: false,
        paynowShow:0,
        cancel_pending_due_details: [],
        total_dues:0,
        isPopupOpen: false,
        showPostPaidBiometric:false,
        activationSessionId:"",
        is_wme_prepaid : 0,

    }


    componentDidMount() {

        this.setState({ loading: true });
        this.setState({ loading: false, activeShow: true });

     const is_wme_prepaid = sessionStorage.getItem('is_wme_prepaid');
      if (is_wme_prepaid === '1') {
        this.setState({ is_wme_prepaid: 1 });
      }
         


        


        this.getUserStatus()
        this.getActivations()
        const { location } = this.props;

        if (location.state && location.state.selectedNumber && location.state.selectedActivation) {
            this.setState({
                selected_number: location.state.selectedActivation,
                selected_mobile_number: location.state.selectedNumber
            });
            this.getAccountSummary(location.state.selectedActivation, location.state.selectedNumber);
            sessionStorage.setItem("prepaid-migration-number",location.state.selectedNumber)
        }


    }


    handleChange = (e) => {
        

        var active_number = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const isWmePrepaid = Number(selectedOption.dataset?.wmePrepaid);
        sessionStorage.setItem("postpaidselectedNum", selectedText)

        this.setState({
            selected_number: active_number,
        });
        // this.getAccountSummary(active_number, selectedText);

        if(isWmePrepaid===1 ||isWmePrepaid===0){
              this.getAccountSummary(active_number, selectedText);

        }else{
              this.prepaidGetAccountSummary(active_number, selectedText);
        }
    };


    getUserStatus = async () => {
        let headers = await getApiHeader();
        let res = await axios.get(`${SERVER_URL}user_status`, { headers }).then(async response => {

            if (response.data.data.forceLogout) {
                if (response.data.data.forceLogout != 'undefined') {
                    if (response.data.data.forceLogout == '1') {
                        this.handleLogout();
                    }
                }
            }

        }).catch(error => {
        });

    };




    getActivations = async () => {
        let headers = await getApiHeader();
        let res = await axios.get(`${SERVER_URL}postpaid/user_activations`, { headers }).then(async response => {

            if (response.data.data.customMessage) {
                if (response.data.data.customMessage != 'undefined') {
                    this.setState({ customMesssge: response.data.data.customMessage });
                }
            }


            let data=response.data.data.list  
            if (data.length < 2 && data[0]?.mobile_number) {
                sessionStorage.setItem("prepaid-migration-number", data[0].mobile_number);
            } 

            let selected_number = '';
            let mobile = '';
            const { location } = this.props;


            if (data.length > 0) {

                if (location.state && location.state.selectedNumber && location.state.selectedActivation) {
                    selected_number = location.state.selectedActivation;
                    mobile = location.state.selectedNumber
                    sessionStorage.setItem("postpaidselectedNum", mobile)


                } else {
                    
                    if (this.state.is_wme_prepaid == 1 || this.state.is_wme_prepaid == 2) {
                        const filtered = data.filter((item) => item.is_wme_prepaid == 1 || item.is_wme_prepaid == 2);
                        selected_number = filtered[0].activation_id;
                        mobile = filtered[0].mobile_number;
                    } else {
                        selected_number = data[0].activation_id;
                        mobile = data[0].mobile_number;
                        sessionStorage.setItem("postpaidselectedNum", mobile)
                        
                    }


                }
            } else {

                selected_number = null;
                mobile = null;
            }
            sessionStorage.setItem('selected_number', selected_number);
            sessionStorage.setItem('postpaid_activation_id',selected_number);
            // console.log('postpaid selected number',selected_number);
            
            sessionStorage.setItem('activation_id', mobile);
            this.setState({
                selected_number: selected_number,
            });
            await this.setState({ customer_activations: data });
            await this.getAccountSummary(selected_number, mobile);
            await this.setState({ loading: false });

        }).catch(error => {
            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                //swal(error.response.data.message, "", "warning");
                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                })
                // .then(() => {

                //     this.handleLogout();

                // });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }


        });

    };

    handleLogout = async () => {



        let p = new Promise(async (resolve, reject) => {

            let headers = await getApiHeader();
            let res = await axios.get(`${SERVER_URL}logout`, { headers });
            let data = res.data.data;
            console.log(data);

            removeUserSession();
            resolve();

        });

        p.then(
            () => {

                this.props.history.push("/login");

            },
            () => {
                alert("Error in logout");
            }
        )

    }

    getAccountSummary = async (activation_id, number,isWmePrepaid) => {
        this.setState({ loading: true });
        this.setState({ activeShow: true });

        try {
             console.log("url-->",isWmePrepaid)

            let url
            if (isWmePrepaid) {
                url =  (isWmePrepaid === 1 || isWmePrepaid === 0)? "postpaid/pst-ac-smy" : "account_summary";
            } else {
                url = "postpaid/pst-ac-smy";
            }


            let headers = await getApiHeader();
            await sessionStorage.setItem('selected_number', number);
            await sessionStorage.setItem('activation_id', activation_id);
            const post_data = { activation_id: activation_id, mobile_number: number };
            let res = await axios.post(`${SERVER_URL}${url}`, post_data, { headers });
            let data = res.data.data.summary;
            let cancel_pending_dues = res.data.data.paynow_service_cancel;
            let total_pending_dues = res.data.data.paynow_service_cancel_total_amount;
            const postPaidBiometricPending = res.data.data?.postpaid_biometric_needed_status
            const activationSessionId = res.data.data.summary?.session_id
            if (data.is_wme_prepaid === 1) {
                this.setState({ is_wme_prepaid: 1 });
            } else if (data.is_wme_prepaid === 2) {
                this.setState({ is_wme_prepaid: 2 });
            }
            else {
                this.setState({ is_wme_prepaid: 0 });
            }

            this.setState({ activationSessionId: activationSessionId })
            if (postPaidBiometricPending) {
                this.setState({ showPostPaidBiometric: true })
            } else {
                if (typeof (res.data.data.continue_activation) != 'undefined') {
                    if (typeof (res.data.data.continue_activation) != null) {
                        let check_activation_continue = res.data.data.continue_activation;
                        if (check_activation_continue !== null) {
                            this.props.history.push({
                                pathname: '/' + check_activation_continue
                            })
                        }
                    }
                }
            }

            let total_data_balance = data.data_balance;
            // let graph_data_used = data.data_used + data.data_bank_used;
            // let graph_data_balance = data.data_balance + data.data_bank_balance;
            let graph_data_used = data.data_used;
            let graph_data_balance = data.data_balance

            // let graph_TotalData = data.data_bank_allowance + data.data_allowance;
            // let graph_usedData = data.data_used + data.data_bank_used;
            // let graph_TotalData = data.data_balance;
            let graph_TotalData = data.data_allowance + data.data_bank_balance;
            let graph_usedData = data.data_used;
            this.setState({ graph_TotalData: graph_TotalData });
            this.setState({ graph_usedData: graph_usedData });
            this.setState({ sixth_recharge_status: data.sixth_recharge_status })
            //  this.setState({recharge_count:0})
            this.setState({ recharge_count: data.recharge_count })
            this.setState({ no_recharge: data.no_recharge })
            // this.setState({no_recharge:false})
            this.setState({ paynowShow: data.paynow_status })




            if (data.activation_status != 1) {
                this.setState({ activeShow: false });
            }
            // if(total_data_balance){
            // 	graph_data_balance = data_balance;
            // }


            var garph_details = {
                labels: ['Used Data', 'Balance Data'],
                datasets: [
                    {
                        label: 'Rainfall',
                        backgroundColor: [
                            '#C11D6C',
                            '#4ac959'
                        ],
                        hoverBackgroundColor: [
                            '#C11D6C',
                            '#4ac959'
                        ],
                        data: [graph_data_used, graph_data_balance]
                    }
                ]
            }
            this.setState({ graph_data: garph_details });
            this.setState({ account_summary: data });
            this.setState({ cancel_pending_due_details: cancel_pending_dues });
            this.setState({ total_dues: total_pending_dues });

            if (typeof (data.gift_data_sent) != 'undefined') {
                if (typeof (data.gift_data_sent) != null) { this.setState({ data_gift_sent: data.gift_data_sent }); }
            }

            if (typeof (data.gift_data_received) != 'undefined') {
                if (typeof (data.gift_data_received) != null) { this.setState({ data_gift_received: data.gift_data_received }); }
            }


            this.setState({ loading: false });
            

    
        }
        catch (err) {

            console.log("errr-->",err)
            

            this.setState({ loading: false });

            if ((typeof (err.response.data.message) !== 'undefined') && (typeof (err.response.data) !== 'undefined')) {

                swal({
                    text: err.response.data.message,
                    icon: "error"
                });
            } else {

                swal({
                    text: "Not available",
                    icon: "error"
                });
            }


        }


    };



   prepaidGetAccountSummary = async (number,biometricCheck) => {

		this.setState({ loading:true});
		this.setState({ activeShow: true });

		try{

		let headers 	= await getApiHeader(); 
		await sessionStorage.setItem('selected_number', number);
		const post_data = { mobile_number: number };
		let res 		= await axios.post(`${ SERVER_URL }account_summary`,post_data, { headers });
		let data 		= res.data.data.summary; 
		let total_data_balance 	= data?.data_balance;
		let graph_data_used 	= data?.data_used + data?.data_bank_used;
		let graph_data_balance 	= data?.data_balance + data?.data_bank_balance; 

		let graph_TotalData 	= data?.data_bank_allowance + data?.data_allowance; 
		let graph_usedData 		= data?.data_used + data?.data_bank_used; 
		this.setState({ graph_TotalData: graph_TotalData }); 
		this.setState({ graph_usedData: graph_usedData }); 
		 this.setState({sixth_recharge_status:data.sixth_recharge_status})
		//  this.setState({recharge_count:0})
		this.setState({recharge_count:data.recharge_count})
		this.setState({no_recharge:data.no_recharge})
		// this.setState({no_recharge:false})

		
			if (data.activation_status != 1) {
				this.setState({ activeShow: false });
				 if(biometricCheck){
					 if (data.activation_status == 6){
						if(!this.state.biometricStatus){
							this.setState({ biometricStatus: true });
							sessionStorage.removeItem("activation_session_id")
							if(data.session_id){
								this.setState({ biometricSessionId: data.session_id });
							}
						} 
					 }else{
						const biometricStatus = sessionStorage.getItem("biometric_needed_status");
						  if (biometricStatus) {
						   sessionStorage.removeItem("biometric_needed_status");
						}
						this.setState({ biometricStatus: false });
					 }
			}
		}
		

		// if(total_data_balance){
		// 	graph_data_balance = data_balance;
		// }
		 

		var garph_details = {	
								labels: ['Used Data', 'Balance Data'],
								datasets: [
									{
									label: 'Rainfall',
									backgroundColor: [
										'#C11D6C',
										'#4ac959'
									],
									hoverBackgroundColor: [
									'#C11D6C',
									'#4ac959'
									],
									data: [graph_data_used, graph_data_balance]
									}
								]
							}
		this.setState({ graph_data: garph_details }); 
		this.setState({ account_summary: data }); 

		if(typeof(data.gift_data_sent) !='undefined'){
			if(typeof(data.gift_data_sent) != null){ this.setState({ data_gift_sent:data.gift_data_sent});  }
		}

		if(typeof(data.gift_data_received) !='undefined'){
			if(typeof(data.gift_data_received) != null){ this.setState({ data_gift_received:data.gift_data_received});  }
		}


        this.setState({ loading:false});

		}
        catch(err)
        {

                  console.log("error------>",err)

            this.setState({loading:false});

			if((typeof(err.response.data.message) !== 'undefined') && (typeof(err.response.data) !== 'undefined'))
            {
 
				swal({
					text: err.response.data.message,
					icon: "error"});
            }else{

				swal({
					text: "Not available",
					icon: "error"});
			}
            

        }


	};













    gotoextraRecharge = async () => {
        window.sessionStorage.setItem("recharge", "pay_as_you_go");
        // window.location.href = "/Recharge";
        // this.props.history.push("/Recharge?extras");

        this.props.history.push({
            pathname: '/Recharge',
            state: { activeSection: 'pay_as_you_go' }
        })

    };

    payNowHandler = async () => {
        this.setState({ loading: true });
        // this.setState({ activeShow: true });
        const post_data = {
          mobile_number: sessionStorage.getItem('selected_number')
        };
        try {
          let headers = await getApiHeader();
          let res = await axios.post(`${SERVER_URL}postpaid/pst-ac-pynw`, post_data, { headers });
          let data = res.data;
        
          this.setState({ loading: false });
          console.log('payNowHandler details----------->',data.data.current_plan_details);
          
          
          if (res.status == 200) {

            swal({
              title: "Plan Details",
              content:
                <div>
                 
                  <p>Plan Name: {data.data.current_plan_details.plan_name}</p>
                
                  <p>Total Amount: ${data.data.current_plan_details.payable_amount}</p>
                 
                  <div>
                    {data.data.current_plan_details.changeRequest && (
                      <h5> You requested to change plan to {data.data.current_plan_details.changeRequest_plan_name} ,during the previous cycle </h5>)}
                  </div>
                  {(
                    <p>Please be aware that the reactivation may take 2-5 business days to be completed.</p>
                  )}
                </div>
              ,
              icon: "",
              buttons: {
                cancel: "Cancel",
                submit: "Confirm & Submit"
              }
            })
              .then((value) => {
                if (value === "submit") {
                  this.confirmHandler()
                } else {
                  // Handle cancel action
                }
              });
          }
          else {
            swal("Internal Server Error", "", "warning");
          }
        }
        catch (err) {
          // console.log("err", err.response.data.message)
          this.setState({ loading: false });
          if (err) {
            let message = err.response.data.message
            swal({
              title: message,
              content: "Error occurred please try again later",
              icon: "error"
            });
          }
    
        }
      }

      confirmHandler = async () => {
          try {
            this.setState({
              model_visibility: false,
              payNow: false, loading: true
            });
      
            const post_data = {
                mobile_number: sessionStorage.getItem('selected_number')
             };
            let headers = await getApiHeader();
            let res = await axios.post(`${SERVER_URL}postpaid/pst-ac-cnfrm-pynw`, post_data, { headers });
            let data = res.status;
            this.setState({ loading: false });
              swal(res.data.message, '', "success").then(() => {
                  window.location.reload();
              });

          } catch (err) {
            this.setState({ loading: false, payNow: true, });
              if (err) {
                  let message = "Something went wrong!";

                  if (err.response && err.response.data && err.response.data.message) {
                      message = err.response.data.message;
                  } else if (err.message) {
                      message = err.message; // fallback to generic error message
                  }

                  swal({
                      title: message,
                      content: "",
                      icon: "error"
                  });
              }
          };
        }



      // Open the popup
      openPopup = () => {
        this.setState({ isPopupOpen: true });
      };

      // Close the popup
      closePopup = () => {
        this.setState({ isPopupOpen: false });
      };

    handleBiometricProcess = async () => {
        try {
            this.setState({ loading: true });
            const headers = await getApiHeaderGuest()
            const sessionId = this.state.activationSessionId
            const post_data = {
                session_id: sessionId,
            };

            const response = await axios.post(`${SERVER_URL}postpaid/activation/biometric-confirmation-postpaid`, post_data, { headers })

            if (response.status === 200) {
                swal(response.data?.message || response.data?.data?.message || "success", "", "success").then(()=>
                    this.handleLogout()
                )
                this.setState({ loading: false });
                return;
            }
        } catch (error) {
            this.setState({ loading: false });
            swal(error.response.data?.message || "", "", "error")
        }

    }




    render() {

        var account_details = this.state.account_summary;
        // console.log("account_details--->",account_details)

        let isShow = true;
        let total_data = 0;
        var main_balance_balance = "";
        var data_bank_balance = "";
        let isIddShow = false;
        let selected_no = account_details.mobile_number;
        var graph_TotalData = this.state.graph_TotalData;
        var graph_usedData = this.state.graph_usedData;
        let not_active_message = "";
        const { recharge_count, no_recharge } = this.state;

        let displayed_recharge_count = recharge_count;
        if (no_recharge) {
            displayed_recharge_count = 0;
        } else if (recharge_count === 0) {
            displayed_recharge_count = 6;
        }

        var isPopupOpen = this.state.isPopupOpen;



        if (account_details) {
            if ((account_details.gender) && (account_details.gender == 'Male')) {
                var profile_image = maleUserImg;
            } else if ((account_details.gender) && (account_details.gender == 'Female')) {
                var profile_image = femaleUserImg;
            } else {
                var profile_image = maleUserImg;
            }
            total_data = parseInt(account_details.data) + parseInt(account_details.bonus_data);
            if (account_details.main_balance_balance) {
                main_balance_balance = "$" + parseFloat(account_details.main_balance_balance).toFixed(2);
            } else {
                main_balance_balance = "";
            }
            if (account_details.idd_pack_balance) {
                isIddShow = true;
            }

            if (account_details.activation_status == 9) {
                not_active_message = "Mobile Number " + selected_no + " has been disconnected. If you have any queries, please feel free to contact Telsim Customer Care through chat or email at support@telsim.com.au or call us at 1300-TELSIM.";
            } else {
                not_active_message = "Mobile Number " + selected_no + " is not active. Your request is in progress. We will send you an email when the activation is complete. If you have any queries, please feel free to contact Telsim Customer Care through chat or email at support@telsim.com.au or call us at 1300-TELSIM.";
            }

        } else {
            isShow = false;
        }


        


        return (
            <>
                <div className="top-container" >
                </div>
                {(this.state.loading === true) ? <PageLoader /> : null}
                <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
                    <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                        <div className="row">
                            <div className="col-lg-10 col-xl-10 order-lg-1 order-xl-1">
                            </div>
                            <div className="col-lg-2 col-xl-2 order-lg-2 order-xl-2">
                                <div className="form-group row">
                                    <div className="col-lg-10 col-md-12 col-sm-12 number-select custom-select num-picker">
                                        <select className="form-select custom-select kt_selectpicker selector" value={this.state.selected_number||""} onChange={this.handleChange} name="activation">

                                            {this.state.customer_activations?.filter(person =>  this.state.is_wme_prepaid == 1  ?  (person.is_wme_prepaid == 1 || person.is_wme_prepaid == 2)  : person.is_wme_prepaid == 0)?. map(person => (
                                                <option
                                                    key={person.activation_id}
                                                    className="m--bg-success kt-font-inverse-success"
                                                    value={person.activation_id}
                                                    data-wme-prepaid={person.is_wme_prepaid} 
                                                    selected={this.state.selected_mobile_number === person.mobile_number ? "selected" : null}
                                                >
                                                    {person.mobile_number}
                                                </option>
                                            ))}


                                        </select>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {isShow ? (
                            <>
                                {(this.state.activeShow === true) ? (
                                    <div className="row mb60">

                                        {(this.state.customMesssge != null) &&
                                            <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">
                                                <div className="customMsg">
                                                    <p>{this.state.customMesssge}</p>
                                                </div>
                                            </div>
                                        }


                                        <div className="col-lg-6 col-xl-6 order-lg-1 order-xl-1">
                                            <div className="kt-portlet kt-widget kt-widget--general-3 kt-portlet--height-fluid post-paid-account-summary-left" style={{ border: '1px solid #C11D6C' }}>
                                                <div className="kt-portlet__head  kt-portlet__head--noborder">
                                                    <div className="kt-portlet__head-label">
                                                        <h3 className="kt-portlet__head-title account_summary_head">Account Summary </h3>
                                                    </div>
                                                </div>
                                                <div className="kt-portlet__body kt-portlet__body--fit" id="accSummary">
                                                    <div id="user_widget">
                                                        <div className="kt-widget__top ptb0">
                                                            <div className="kt-media kt-media--lg kt-media--circle">
                                                                <img src={profile_image} alt="image" />

                                                            </div>
                                                            <div className="kt-widget__wrapper">
                                                                <div className="kt-widget__label">
                                                                    <a className="kt-widget__title">
                                                                        {account_details.firstName} {account_details.middleName} {account_details.surname}
                                                                    </a>
                                                                    <span className="email-custom">{account_details.email}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="kt-widget__top ptb10">
                                                            <div className="kt-widget__wrapper">
                                                                <div className="kt-widget__links">
                                                                    <div className="kt-widget__cont">
                                                                        {/* <div className="kt-widget__link">
                                                                            {account_details.offer_data?.plan_name ?
                                                                                <>
                                                                                    <i className="flaticon2-paperplane  kt-font-brand sim-only-current-tag"></i>  Current Plan : &nbsp;<a className="sim-only-current-plan sim-only-plan-plan-name ">  {account_details.offer_data?.plan_name} $<span className="strike-through">{account_details?.offer_data?.plan_type}</span> ${account_details?.offer_data?.plan_price} {account_details?.offer_data?.validity}
                                                                                    </a>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <i className="flaticon2-paperplane  kt-font-brand sim-only-current-tag"></i>  Current Plan : &nbsp;<a className="sim-only-current-plan sim-only-plan-plan-name ">    {account_details?.plan_name ? account_details?.plan_name :account_details?.activated_plan_data?.offerName}
                                                                                    </a>
                                                                                </>
                                                                            } 

                                                                        </div> */}

                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon2-paperplane kt-font-brand sim-only-current-tag"></i> Current Plan : &nbsp;
                                                                            <a className="sim-only-current-plan">
                                                                                {account_details?.amount > account_details?.sell_amount &&account_details?.promotional_offer_status===1 ? (
                                                                                    <>
                                                                                        {account_details?.total_data} GB&nbsp;
                                                                                        <del>${account_details?.amount}</del>&nbsp;
                                                                                        ${account_details?.sell_amount}&nbsp;
                                                                                        {"("}
                                                                                        {account_details?.offer_validity}{" "}
                                                                                        {account_details?.offer_validity === 1 ? "Month" : "Months"} Offer{")"}{" "}
                                                                                        {account_details?. is_wme_prepaid ===1 || account_details?.is_wme_prepaid === 2? "Prepaid Plan":"SIM Only Plan" }                 

                                                                                    </>
                                                                                ) : (
                                                                                    <div className="kt-widget__link">
                                                                                        {account_details.offer_data?.plan_name ?
                                                                                            <>
                                                                                                <a className="sim-only-current-plan sim-only-plan-plan-name ">  {account_details.offer_data?.plan_name} $<span className="strike-through">{account_details?.offer_data?.plan_type}</span> ${account_details?.offer_data?.plan_price} {account_details?.offer_data?.validity}
                                                                                                </a>
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                            <a className="sim-only-current-plan sim-only-plan-plan-name ">    {account_details.is_wme_prepaid===1 ||account_details.is_wme_prepaid===2 ?"Telsim Prepaid Plan":"Telsim Sim Only Plan"}
                                                                                                </a>
                                                                                            </>
                                                                                        }

                                                                                    </div>

                                                                                )}
                                                                            </a>
                                                                        </div>

                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon2-time  kt-font-brand"></i> Expiry : &nbsp;<a> {account_details.expiry_date}</a>
                                                                        </div>
                                                                        {this.state.is_wme_prepaid != 1 && (
                                                                              <div className="kt-widget__link">
                                                                            <i className="flaticon2-time  kt-font-brand"></i> Next Billing : &nbsp;<a> {account_details.next_pay_date}</a>
                                                                        </div>
                                                                         )}
                                                                           
                                                                      
                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon-coins  kt-font-brand"></i> Main Balance : &nbsp;<a>{main_balance_balance} </a>
                                                                        </div>
                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon-up-arrow kt-font-brand"></i> IDD Pack Balance : &nbsp;
                                                                            {/* <a>{account_details.idd_pack_balance} / {account_details.idd_pack_allowance} mins</a> */}
                                                                            {isIddShow ? (
                                                                                <a>{account_details.idd_pack_balance} / {account_details.idd_pack_allowance} mins</a>
                                                                            ) : (
                                                                                <a></a>
                                                                            )}
                                                                        </div>

                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon-gift  kt-font-brand"></i> Data Gifted : &nbsp;<a>{this.state.data_gift_sent} GB </a>
                                                                        </div>
                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon-gift  kt-font-brand"></i> Data Received : &nbsp;<a>{this.state.data_gift_received} GB</a>
                                                                        </div>



                                                                    </div>
                                                                </div>
                                                                <div className="kt-widget__links">
                                                                    <div className="kt-widget__cont">
                                                                        <div className="kt-widget__link ">
                                                                            <i className="flaticon2-phone  kt-font-brand "></i><a>{account_details.mobile_number}</a>
                                                                        </div>
                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon2-pie-chart-2  kt-font-brand"></i> Data Balance : &nbsp;<a> {account_details.data_balance} GB </a>

                                                                        </div>
                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon2-pie-chart-2  kt-font-brand"></i> Data Bank Balance : &nbsp;<a> {account_details.data_bank_balance} GB </a>

                                                                        </div>
                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon2-calendar-3  kt-font-brand"></i> Days Remaining : &nbsp;<a>{account_details.remaining_days} </a>
                                                                        </div>
                                                                        <div className="kt-widget__link">
                                                                            <i className="flaticon-star  kt-font-brand"></i> Telsim Wallet Balance	 : &nbsp;<a> ${account_details.credit_balance}</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>



                                                        {account_details?.roaming_pack_status == '1' ?
                                                            <div className="kt-widget__top ptb10">
                                                                <div className="kt-widget__wrapper">

                                                                    <div className="kt-widget__links">
                                                                        <div className="kt-widget__cont">

                                                                            <div className="kt-widget__link">
                                                                                <i className="flaticon-globe  kt-font-brand"></i> IR Pack : &nbsp;<a> {account_details.ir_pack_name}</a>
                                                                            </div>

                                                                            <div className="kt-widget__link">
                                                                                <i className="flaticon-globe  kt-font-brand"></i> IR Expiry: &nbsp;<a> {account_details.data_ir_expiry}</a>
                                                                            </div>

                                                                            {account_details.ir_activation == 'NA' ?
                                                                                <>
                                                                                <div className="kt-widget__link">
                                                                                    <i className="flaticon-globe  kt-font-brand"></i> IR Data Balance : &nbsp;<a>{account_details.ir_activation}</a>
                                                                                </div>

                                                                                    {account_details.ir_money_balance && (

                                                                                        <div className="kt-widget__link">
                                                                                            <i className="flaticon-globe  kt-font-brand"></i>IR Pack - Wallet : &nbsp;<a> ${account_details.ir_money_balance}</a>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                                :
                                                                                <div className="kt-widget__link">
                                                                                    <i className="flaticon-globe  kt-font-brand"></i> IR Data Balance : &nbsp;<a>{account_details.data_ir_data_balance} / {account_details.data_ir_data_allowance} GB</a>
                                                                                </div>

                                                                            }


                                                                        </div>
                                                                    </div>
                                                                    <div className="kt-widget__links">
                                                                        <div className="kt-widget__cont">


                                                                            {account_details.ir_activation == 'NA' ?

                                                                                <>
                                                                                    <div className="kt-widget__link">
                                                                                        <i className="flaticon-globe  kt-font-brand"></i> IR Voice Balance : &nbsp;<a>{account_details.ir_activation}</a>
                                                                                    </div>

                                                                                    <div className="kt-widget__link">
                                                                                        <i className="flaticon-globe  kt-font-brand"></i> IR SMS Balance : &nbsp;<a>{account_details.ir_activation}</a>
                                                                                    </div>
                                                                                </>

                                                                                :
                                                                                <>
                                                                                    <div className="kt-widget__link">
                                                                                        <i className="flaticon-globe  kt-font-brand"></i> IR Voice Balance : &nbsp;<a>{account_details.data_ir_voice_balance} / {account_details.data_ir_voice_allowance} mins</a>
                                                                                    </div>

                                                                                    <div className="kt-widget__link">
                                                                                        <i className="flaticon-globe  kt-font-brand"></i> IR SMS Balance : &nbsp;<a>{account_details.data_ir_sms_balance} / {account_details.data_ir_sms_allowance}</a>
                                                                                    </div>
                                                                                </>
                                                                            }


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : null
                                                        }



                                                    </div>
                                                </div>
                                                <div className="kt-portlet__body kt-portlet__body--fit">
                                                    <div className="kt-form__actions">
                                                       

                                                        <div className="row" >
                                                             
                                                            
                                                           
                                                        </div>



                                                        <PaymentPopup
                                                          isOpen={isPopupOpen}
                                                          closePopup={this.closePopup}
                                                          dueAmount={this.state.total_dues}
                                                          dueList={this.state.cancel_pending_due_details}
                                                        />



                                                    </div>
                                                </div>
                                                <div className="col-md-12" style={{ margin: "10px", display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "left" }}>

                                                    {this.state.is_wme_prepaid === 1 || this.state.is_wme_prepaid === 2 ? (
                                                         <>

                                                           

                                                        <>
                                                            <div className="col-md-6 col-lg-12">
                                                                <div className="kt-portlet__foot">
                                                                    <div className="kt-form__actions">
                                                                        <div className="row">
                                                                            <div className="col-md-4">
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <Link to="/RechargeHome" className="btn btn-brand">Recharge</Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>

                                                        </>
                                                    ) : (
                                                        <>
                                                            {this.state.paynowShow == 1 && (
                                                                <Link to="#" onClick={(e) => { e.preventDefault(); this.payNowHandler() }} className="custom-pill-button">
                                                                    Pay Now
                                                                </Link>
                                                            )}
                                                            <Link to="/add-packs" className="custom-pill-button">
                                                                Add Pack
                                                            </Link>
                                                        </>
                                                    )}


                                                    {this.state.total_dues > 0 && (
                                                        <button onClick={this.openPopup} className="custom-pill-button" style={{ border: 'none' }}>
                                                            Pending Due ${this.state.total_dues}.00
                                                        </button>
                                                    )}



                                                </div>





                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-xl-6 order-lg-1 order-xl-1"  >
                                            <div className="kt-portlet kt-portlet--height-fluid tabgight-fix" style={{ border: '1px solid #C11D6C' }}>
                                                <div className="kt-portlet__head  kt-portlet__head--noborder">
                                                    <div className="kt-portlet__head-label">
                                                        <h3 className="kt-portlet__head-title account_summary_head">Data Usage </h3>
                                                    </div>
                                                </div>
                                                {/* <div className="kt-portlet__body kt-portlet__body--fluid"  style ={{height: '300px',margin:'auto',position:'relative',width:'300px'}}> */}
                                                <div className="kt-portlet__body kt-portlet__body--fit" style={{ height: '300px', margin: 'auto', position: 'relative', width: '300px' }}>
                                                    <Doughnut
                                                        data={this.state.graph_data}
                                                        width={'100%'}
                                                        height={'100%'}
                                                        options={{
                                                            title: {
                                                                display: true,
                                                                text: 'Data Usage',
                                                                fontSize: 20
                                                            },
                                                            legend: {
                                                                display: true,
                                                                position: 'right'
                                                            }
                                                        }}
                                                    />


                                                </div>
                                                <div className="kt-portlet__foot p0">
                                                    <div className="kt-form__actions">
                                                        <div className="row mt10">
                                                            <div className="col-md-12 text-center">
                                                                <div className="kt-widget__link">
                                                                    <i className="flaticon2-pie-chart-2  kt-font-brand"></i> Data Used/Total Data : &nbsp;<a> <span id="span_data_used">{graph_usedData}</span> GB / <span id="span_total_data">{graph_TotalData} GB </span> </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <br />
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                            </div>
                                                            {this.state.is_wme_prepaid === 1 || this.state.is_wme_prepaid === 2 ? (
                                                                <div className="col-md-6">
                                                                    <a data-toggle="tooltip" data-original-title="Edit" className="btn btn-brand" onClick={this.gotoextraRecharge} >Add Extras</a>
                                                                </div>):
                                                                <>
                                                                
                                                                </>
                                                                
                                                                }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (

                                        <>

                                            {this.state.showPostPaidBiometric ? (
                                                <>
                                                    <div className="biometric-overlay">
                                                        <div className="biometric-card">

                                                            <div className="biometric-header">
                                                                <div className="biometric-icon">
                                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                        <path d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4" />
                                                                    </svg>
                                                                </div>
                                                                <div>
                                                                    <div className="biometric-title">Biometric Summary</div>
                                                                    <div className="biometric-subtitle">Identity verification required</div>
                                                                </div>
                                                            </div>

                                                            <div className="customMsg">
                                                                <div className="" />
                                                                <p>Please complete Biometric verification to  complete your Activation </p>
                                                            </div>

                                                            <div className="divider" />

                                                            <button className="btn-activate" onClick={this.handleBiometricProcess}>
                                                                Complete Activation
                                                            </button>

                                                        </div>
                                                    </div>
                                                </>
                                            ) :

                                                <div className="row" >
                                                    <h5 style={{ color: '#C11D6C' }}>
                                                        {not_active_message}</h5>
                                                </div>
                                            }

                                        </>
                                )}
                            </>
                        ) : (
                            <div className="row">
                                <h2>No Details Available</h2>
                            </div>
                        )}
                    </div>
                </div>

            </>
        )
    }
}

export default withRouter(PostPaidAccoutSummary);